module.exports = __webpack_public_path__ + "e3fc9927ecb4d5e865a95526b94f5f11.svg";